import { useAppDispatch } from '../hooks';
import { signIn, signOut } from '../reducers/authReducer';

export interface AuthActions {
    signInUser: (userId?: string) => void;
    signOutUser: () => void;
}
export const useAuthActions = () => {

    const dispatch = useAppDispatch();

    const signInUser = (userId?: string) => {
        dispatch(signIn(userId));
    }

    const signOutUser = () => {
        dispatch(signOut());
    }

    return { signInUser, signOutUser };
}